// copied from VPC.

import AxiosHttpClient from './AxiosHttpClient';
import { SendRequest } from '../../models/httpClient/IServer';
import { IRequest } from '../../models/httpClient/IRequest';
import { IResult } from '../../models/httpClient/IResponse';

/**
 * This library implements HTTP client for Web Client APIs.
 * Web Client APIs serve most of the Tableau Server UI - VizPortalClient
 */
namespace WebHttpClient {
  /**
   * Prefix for the Web Client API, which is how most VizPortal Client requests are made.
   * @constant
   * @type {string}
   * @default
   */
  export const API_PREFIX: string = 'vizportal/api/web/v1/';

  /**
   * Make a server request using the Web Client API. The request is made `within` session, aka after getSessionInfo call finishes
   * @param {IRequest} request - request object
   * @returns {Promise} Promise that resolves with server response
   */
  export const sendRequest: SendRequest = function sendRequest<TParams, TResult>(request: IRequest<TParams, TResult>): Promise<TResult> {
    // TODO: check if there is a request pending that might change the session and wait until that request is finished
    return requestPost(request) as Promise<TResult>;
  };

  /**
   * Makes http POST request to Web Client API. The request does not wait for getSessionInfo call. Use {sendRequest} if the request must wait for getSessionInfo call.
   * @param {IRequest} request - request object
   * @returns {Promise} Promise that resolves with server response
   */
  export function requestPost<TParams, TResult extends IResult>(request: IRequest<TParams, TResult>): Promise<TResult | null | undefined> {
    return AxiosHttpClient.makeAxiosRequest<TResult>({
      method: 'POST',
      url: API_PREFIX + request.method,
      data: {
        method: request.method,
        params: request.params,
      },
      headers: request.headers,
      timeout: 3000,
    });
  }
}

export default WebHttpClient;
